import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import GateDocumentActions, { gateDocumentActionTypes } from '../../../actions/logistics/gateDocument/gateDocumentActions';
import gateDocumentServices from '../../../services/logistics/gateDocument/gateDocumentServices';

function* _getGateDocument(action) {
  try {
    yield put(GateDocumentActions.getGateDocumentByIdLoading(true));
    const {
      payload, callback
    } = action;
    const gateDoc = yield gateDocumentServices.getGateDocumentById(payload);
    yield put(GateDocumentActions.getGateDocumentByIdSuccess(gateDoc?.data));
    if (callback) callback(gateDoc?.data);
    yield put(GateDocumentActions.getGateDocumentByIdLoading(false));
  } catch (error) {
    yield put(GateDocumentActions.getGateDocumentByIdLoading(false));
    notification.open({
      type: 'error',
      message: `${error?.error_code || ''}: ${error?.message || ''}`,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.ERROR, error));
  }
}
function* getGateDocumentById() {
  yield takeLatest(gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.REQUEST, _getGateDocument);
}

function* _createGateDocument(action) {
  try {
    yield put(GateDocumentActions.createGateDocumentLoading(true));
    const {
      payload, callback,
    } = action;
    const gateDoc = yield gateDocumentServices.createGateDocument(payload);
    if (gateDoc.success) {
      notification.open({
        type: 'success',
        message: 'Gate Document successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(gateDoc?.data);
      yield put(GateDocumentActions.createGateDocumentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${gateDoc?.error_code || ''} : ${gateDoc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.createGateDocumentLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.createGateDocumentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.CREATE_GATE_DOCUMENT.ERROR, error));
  }
}
function* createGateDocument() {
  yield takeLatest(gateDocumentActionTypes.CREATE_GATE_DOCUMENT.REQUEST, _createGateDocument);
}

function* _gateDocumentListScreen(action) {
  try {
    yield put(GateDocumentActions.getGateDocumentsLoading(true));
    const {
      payload, callback,
    } = action;
    const gateDocList = yield gateDocumentServices.getGateDocuments(payload);
    yield put(GateDocumentActions.getGateDocumentsSuccess(gateDocList?.data));
    if (callback) callback(gateDocList?.data);
    yield put(GateDocumentActions.getGateDocumentsLoading(false));
  } catch (error) {
    yield put(GateDocumentActions.getGateDocumentsLoading(false));
    notification.open({
      type: 'error',
      message: `${error?.error_code || ''}: ${error?.message || ''}`,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.GET_GATE_DOCUMENTS.ERROR, error));
  }
}
function* getGateDocuments() {
  yield takeLatest(gateDocumentActionTypes.GET_GATE_DOCUMENTS.REQUEST, _gateDocumentListScreen);
}

function* _linkContacts(action) {
  try {
    yield put(GateDocumentActions.linkContactsLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.linkContacts(payload);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.linkContactsLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.linkContactsLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.linkContactsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.LINK_CONTACTS.ERROR, error));
  }
}
function* linkContacts() {
  yield takeLatest(gateDocumentActionTypes.LINK_CONTACTS.REQUEST, _linkContacts);
}

function* _unlinkContacts(action) {
  try {
    yield put(GateDocumentActions.unlinkContactsLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.unlinkContacts(payload);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.unlinkContactsLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.unlinkContactsLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.unlinkContactsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.UNLINK_CONTACTS.ERROR, error));
  }
}
function* unlinkContacts() {
  yield takeLatest(gateDocumentActionTypes.UNLINK_CONTACTS.REQUEST, _unlinkContacts);
}

function* _linkDocuments(action) {
  try {
    yield put(GateDocumentActions.linkDocumentsLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.linkDocuments(payload, callback);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.linkDocumentsLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.linkDocumentsLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.linkDocumentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.LINK_DOCUMENTS.ERROR, error));
  }
}
function* linkDocuments() {
  yield takeLatest(gateDocumentActionTypes.LINK_DOCUMENTS.REQUEST, _linkDocuments);
}

function* _unlinkDocuments(action) {
  try {
    yield put(GateDocumentActions.unlinkDocumentsLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.unlinkDocuments(payload, callback);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.unlinkDocumentsLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.unlinkDocumentsLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.unlinkDocumentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.UNLINK_DOCUMENTS.ERROR, error));
  }
}
function* unlinkDocuments() {
  yield takeLatest(gateDocumentActionTypes.UNLINK_DOCUMENTS.REQUEST, _unlinkDocuments);
}

function* _updateDocumentStatus(action) {
  try {
    yield put(GateDocumentActions.updateDocumentStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.updateDocumentStatus(payload, callback);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.updateDocumentStatusLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.updateDocumentStatusLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.updateDocumentStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.UPDATE_DOCUMENT_STATUS.ERROR, error));
  }
}
function* updateDocumentStatus() {
  yield takeLatest(gateDocumentActionTypes.UPDATE_DOCUMENT_STATUS.REQUEST, _updateDocumentStatus);
}
function* _quickUpdateGateDocument(action) {
  try {
    yield put(GateDocumentActions.quickUpdateGateDocumentLoading(true));
    const {
      payload, callback,
    } = action;
    const Doc = yield gateDocumentServices.quickUpdateGateDocument(payload, callback);
    if (Doc.success) {
      notification.open({
        type: 'success',
        message: Doc?.message,
        duration: 4,
        placement: 'top',
      });
      action.callback(Doc?.data);
      yield put(GateDocumentActions.quickUpdateGateDocumentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: `${Doc?.error_code || ''} : ${Doc?.message || ''}`,
        duration: 4,
        placement: 'top',
      });
      yield put(GateDocumentActions.quickUpdateGateDocumentLoading(false));
    }
  } catch (error) {
    yield put(GateDocumentActions.quickUpdateGateDocumentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(gateDocumentActionTypes.QUICK_UPDATE_GATE_DOCUMENT.ERROR, error));
  }
}
function* quickUpdateGateDocument() {
  yield takeLatest(gateDocumentActionTypes.QUICK_UPDATE_GATE_DOCUMENT.REQUEST, _quickUpdateGateDocument);
}

export default function* gateDocumentSaga() {
  yield all([
    getGateDocumentById(),
    createGateDocument(),
    getGateDocuments(),
    linkContacts(),
    unlinkContacts(),
    linkDocuments(),
    unlinkDocuments(),
    updateDocumentStatus(),
    quickUpdateGateDocument(),
  ]);
}
